import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';

lessRequire('modules/offers/components/restricted-geo/main.less');

const propTypes = {
	intl: PropTypes.func,
	data: PropTypes.array
};

const RestrictedGeo = ({ intl, data }) => {
	const dataWithGeoRestrictions = data.filter(entity => entity.location_restrictions);

	if (dataWithGeoRestrictions.length === 0) return null;

	return (
		<div className="container__content restricted-geo">
			<div className="container__content-title">
				<h2 className="font-proxima-nova-bold">{intl('Ограничение по ГЕО')}</h2>
			</div>
			<div className="restricted-geo__wrapper">
				<p className="restricted-geo__info">{intl('Заявки не принимаются из следующих регионов')}:</p>
				<div className="restricted-geo__list">
					{ dataWithGeoRestrictions.map((location, i) => (
						<div className="restricted-geo__list-item" key={i}>
							<span className={
								`restricted-geo__list-item__flag
								flag-icon flag-icon-${location.locationCountryCode.toLowerCase()}`
							} />
							<span className="restricted-geo__list-item__text">
								<span>{location.locationTitle} - </span>
								<span dangerouslySetInnerHTML={{__html: location.location_restrictions}} />
							</span>
						</div>
					)) }
				</div>
			</div>
		</div>
	);
};

RestrictedGeo.propTypes = propTypes;

export default RestrictedGeo;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/restricted-geo/main.js